import { render, staticRenderFns } from "./CampaignDetailModal.vue?vue&type=template&id=5e73164f&scoped=true"
import script from "./CampaignDetailModal.vue?vue&type=script&lang=js"
export * from "./CampaignDetailModal.vue?vue&type=script&lang=js"
import style0 from "./CampaignDetailModal.vue?vue&type=style&index=0&id=5e73164f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e73164f",
  null
  
)

export default component.exports